// Vouchers Form
import { useEffect, useState } from "react";
import { format } from "date-fns";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { API } from "@/App";
import api from "@/api/axios";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function VoucherForm({
  defaultDate,
  defaultProjectId,
  userId,
  projects,
  onAdded,
}) {
  const [vf, setVf] = useState({
    date: defaultDate || format(new Date(), "yyyy-MM-dd"),
    type: "Travel",
    amount: "",
    description: "",
    project_id: defaultProjectId || "",
  });
  useEffect(() => {
    setVf((v) => ({
      ...v,
      date: defaultDate || v.date,
      project_id: defaultProjectId || v.project_id,
    }));
  }, [defaultDate, defaultProjectId]);
  const submit = async (e) => {
    e.preventDefault();
    if (!userId || !vf.amount) return;
    try {
      await api.post(`${API}/vouchers`, {
        user_id: userId,
        project_id: vf.project_id || null,
        date: vf.date,
        type: vf.type,
        amount: Number(vf.amount || 0),
        description: vf.description || null,
      });
      setVf({
        date: vf.date,
        type: "Travel",
        amount: "",
        description: "",
        project_id: vf.project_id,
      });
      if (onAdded) onAdded();
    } catch (ex) {
      alert(ex.response?.data?.detail || "Failed to add voucher");
    }
  };
  return (
    <form onSubmit={submit} className="form-grid mini">
      <div>
        <Label>Date</Label>
        <Input
          type="date"
          value={vf.date}
          onChange={(e) => setVf({ ...vf, date: e.target.value })}
        />
      </div>
      <div>
        <Label>Type</Label>
        <Select
          value={vf.type}
          onValueChange={(v) => setVf({ ...vf, type: v })}
        >
          <SelectTrigger className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Travel">Travel</SelectItem>
            <SelectItem value="Meals">Meals</SelectItem>
            <SelectItem value="Supplies">Supplies</SelectItem>
            <SelectItem value="Other">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="">
        <Label>Project (optional)</Label>
        <Select
          value={vf.project_id}
          onValueChange={(v) => setVf({ ...vf, project_id: v })}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Link to project (optional)" />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {projects.map((p) => (
              <SelectItem key={p._id} value={p._id}>
                {p.code} — {p.name}-(Current-Stage:{p.current_stage_idx})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>Amount (₹)</Label>
        <Input
          type="number"
          value={vf.amount}
          onChange={(e) => setVf({ ...vf, amount: e.target.value })}
        />
      </div>
      <div className="col-span-2">
        <Label>Description</Label>
        <Input
          value={vf.description}
          onChange={(e) => setVf({ ...vf, description: e.target.value })}
          placeholder="Optional"
        />
      </div>

      <div className="col-span-2">
        <Button type="submit">Add Voucher</Button>
      </div>
    </form>
  );
}
